/**
 * Generator / engine / alternator / ATS makes seen in OfficeHub data. Used ONLY to flag a make sitting in a
 * model or serial field, or a near-miss spelling. Never used to fill or correct a value.
 * Add a make here when the junk report shows it as a false "misspelled" flag. Aliases map to one canonical name.
 * Onan and Cummins stay distinct (Nick's open naming decision).
 */
export const KNOWN_MAKES: Readonly<Record<string, string>> = Object.freeze({
  KOHLER: 'Kohler', GENERAC: 'Generac', CATERPILLAR: 'Caterpillar', CAT: 'Caterpillar', CUMMINS: 'Cummins',
  ONAN: 'Onan', JOHNDEERE: 'John Deere', DEERE: 'John Deere', PERKINS: 'Perkins', VOLVO: 'Volvo', FPT: 'FPT',
  MTU: 'MTU', DETROITDIESEL: 'Detroit Diesel', SPECTRUM: 'Spectrum', DOOSAN: 'Doosan', MITSUBISHI: 'Mitsubishi',
  KUBOTA: 'Kubota', ISUZU: 'Isuzu', FORD: 'Ford', GM: 'GM', PSI: 'PSI', STAMFORD: 'Stamford', MARATHON: 'Marathon',
  LEROYSOMER: 'Leroy-Somer', MECCALTE: 'Mecc Alte', ASCO: 'ASCO', ZENITH: 'Zenith', RUSSELECTRIC: 'Russelectric',
  PRAMAC: 'Pramac', BALDOR: 'Baldor', OLYMPIAN: 'Olympian', KATOLIGHT: 'Katolight', MAGNAPLUS: 'MagnaPlus',
  WACKERNEUSON: 'Wacker Neuson', ATLASCOPCO: 'Atlas Copco', HIMOINSA: 'Himoinsa', SDMO: 'SDMO', IVECO: 'Iveco',
});

/** True when `key` (already reduced to A-Z0-9) is a known make. Own keys only: never an inherited Object property. */
export function isKnownMake(key: string): boolean {
  return Object.prototype.hasOwnProperty.call(KNOWN_MAKES, key);
}
